module.exports = __webpack_public_path__ + "static/media/table-sort-desc.479b09f3.svg";